<template>
	<div>
		<div class="special-r">
			<div class="special-title show-one-lines" v-text="param.title"></div>
			<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank" v-for="(item,index) in param.list[0].goods_list" :key="index">
				<div class="special-r-item d-flex align-items-center">
					<img src='../../../assets/images/top1.svg' alt v-if="index == 0"/>
					<img src='../../../assets/images/top2.svg' alt v-if="index == 1"/>
					<img src='../../../assets/images/top3.svg' alt v-if="index == 2"/>
					<img src='../../../assets/images/top4.svg' alt v-if="index == 3"/>
					<img class="special-r-item-goods" :src="item.pic_url" alt />
					<div class="special-r-item-box">
						<div v-text="item.name"></div>
						<div v-text="'¥'+item.price"></div>
					</div>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				
			};
		}
	};
</script>

<style lang="scss" scoped>
	.special-r {
		width: 390px;
		height: 417px;
		margin-top: 20px;
		background-color: #fff;
		padding: 0 20px 20px 20px;
		box-sizing: border-box;

		.special-title {
			line-height: 58px;
			height: 58px;
			font-size: 18px;
			font-weight: 600;
		}
		a{
			display: block;
			margin-bottom: 18px;
			.special-r-item {

				:first-child {
					width: 27px;
					height: 39px;
				}

				.special-r-item-goods {
					width: 69px;
					height: 69px;
					margin-left: 14px;
				}

				.special-r-item-box {
					margin-left: 16px;

					:first-child {
						width: 223px;
						height: 34px;
						margin-bottom: 12px;
						overflow: hidden;
						line-height: 18px;

						&:hover {
							color: #ff0e25;
						}
					}

					:last-child {
						color: #ff0e25;
						font-size: 16px;
					}
				}
			}
		}
		a:last-child{
			margin-bottom: 0;
		}
	}
</style>
